import React from "react";
import Alert from "@mui/material/Alert";

const AlertComponent = ({ message, severity }) => {
  return (
    <div>
      {message && (
        <Alert severity={severity} sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
    </div>
  );
};

export default AlertComponent;
